<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="设备编号" v-model="devId"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="机构" v-model="institution"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="型号" v-model="termVersion"></el-input>
      </el-col>
      <el-col :span="10">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
      <el-col :span="2">
        <router-link to="/equipment/portable/equi/add">
          <el-button type="success">新增</el-button>
        </router-link>
      </el-col>
    </el-row>
    <el-row class="search-add" :gutter="10">
      <el-col :span="3">
        <el-button type="primary" @click="openExcel">导出</el-button>
      </el-col>
    </el-row>

    <el-table
      :data="data"
      border
      row-key="id"
      stripe
      style="width: 100%"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="id" label="设备编号" width="160">
      </el-table-column>
      <el-table-column prop="devAlias" label="设备名称"> </el-table-column>
      <el-table-column prop="machineName" label="整机名称"> </el-table-column>
      <el-table-column prop="termVersion" label="整机型号"> </el-table-column>
      <el-table-column prop="firmVersion" label="固件版本"> </el-table-column>
      <el-table-column prop="romModel" label="固件型号"> </el-table-column>
      <el-table-column prop="institution" label="机构/个人"> </el-table-column>
      <el-table-column prop="stockStatus" label="库存状态">
        <template slot-scope="scope">
          {{ scope.row.stockStatus | kucun }}
        </template>
      </el-table-column>
      <el-table-column prop="useStatus" label="使用状态"> </el-table-column>
      <el-table-column prop="poweronTime" label="开机时间">
      </el-table-column>
      <el-table-column prop="lastReportTime" label="最近上报数据时间">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <router-link :to="'/equipment/portable/equi/lishi/' + scope.row.id">
            <el-button type="text" size="small">查看历史数据</el-button>
          </router-link>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      v-show="false"
      :data="data"
      border
      stripe
      style="width: 100%"
      id="out-table"
    >
      <el-table-column prop="devAlias" label="设备名称"> </el-table-column>
      <el-table-column prop="name" label="整机名称"> </el-table-column>
      <el-table-column prop="termVersion" label="整机型号"> </el-table-column>
      <el-table-column prop="firmVersion" label="固件版本"> </el-table-column>
      <el-table-column prop="institution" label="机构"> </el-table-column>
      <el-table-column prop="stockStatus" label="库存状态">
        <template slot-scope="scope">
          {{ scope.row.stockStatus | kucun }}
        </template>
      </el-table-column>
      <el-table-column prop="poweronTime" label="开机时间">
      </el-table-column>
      <el-table-column prop="lastReportTime" label="最近上报数据时间">
      </el-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>

    <el-dialog title="导出Excel" :visible.sync="open" @close="closeDailog">
      <el-radio-group v-model="radio1" class="tab">
        <el-radio-button label="根据结束设备编码导出"></el-radio-button>
        <el-radio-button label="根据设备数量导出"></el-radio-button>
      </el-radio-group>
      <el-form
        v-show="radio1 == '根据结束设备编码导出'"
        :model="rule"
        :rules="rules"
        ref="forms1"
        class="demo-ruleForm"
        label-width="120px"
      >
        <el-form-item label="起始设备编号" prop="start_id">
          <el-input
            placeholder="请输入起始设备编号"
            v-model="rule.start_id"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="结束设备编号" prop="end_id">
          <el-input
            placeholder="请输入结束设备编号"
            v-model="rule.end_id"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form
        v-show="radio1 == '根据设备数量导出'"
        :model="rule2"
        :rules="rules2"
        ref="forms2"
        class="demo-ruleForm"
        label-width="120px"
      >
        <el-form-item label="起始设备编号" prop="start_id">
          <el-input
            placeholder="请输入起始设备编号"
            v-model="rule2.start_id"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="设备数量" prop="count">
          <el-input
            placeholder="请输入设备数量"
            type="number"
            min="1"
            v-model="rule2.count"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDailog">取 消</el-button>
        <el-button type="primary" @click="getExcel">导 出</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
// import FileSaver from 'file-saver'
// import XLSX from 'xlsx'
export default {
  name: "admin",
  data() {
    return {
      devId: "",
      institution: "",
      termVersion: "",
      open: false,
      radio1: "根据结束设备编码导出",
      data: [],
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      rule: {
        start_id: "",
        end_id: "",
      },
      rule2: {
        start_id: "",
        count: "",
      },
      rules: {
        start_id: { required: true, message: "请输入起始设备编号" },
        end_id: { required: true, message: "请输入结束设备编号" },
      },
      rules2: {
        start_id: { required: true, message: "请输入起始设备编号" },
        count: { required: true, message: "请输入设备数量" },
      },
    };
  },
  filters: {
    kucun(value) {
      switch (value) {
        case "0":
          return "待入库";
          break;
        case "1":
          return "入库";
          break;
        case "2":
          return "出库";
          break;
      }
    },
  },
  methods: {
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
        termType: "portable"
      };
      if (this.devId.trim() != "") {
        params.devId = this.devId;
      }
      if (this.institution.trim() != "") {
        params.institution = this.institution;
      }
      if (this.termVersion.trim() != "") {
        params.termVersion = this.termVersion;
      }
      this.$http.post("/manage/dev/list", params).then((results) => {
        this.data = results["data"]["data"]["records"];
        this.pagin.total = results["data"]["data"]["total"];
      });
    },
    exportExcel() {
      var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"));
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "设备信息.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    openExcel() {
      this.open = true;
    },
    closeDailog() {
      this.open = false;
      this.$refs["forms1"].resetFields();
      this.$refs["forms2"].resetFields();
    },
    getExcel() {
      if (this.radio1 == "根据结束设备编码导出") {
        this.handleGetExcel(this.rule, "forms1");
      } else {
        this.handleGetExcel(this.rule2, "forms2");
      }
    },
    handleGetExcel(rule, forms) {
      this.$refs[forms].validate((valid) => {
        if (valid) {
          this.$http
            .get("/manage/virtual_device/export_virtual_devices", {
              params: rule,
            })
            .then(({ data }) => {
              if (data.code == 0) {
                window.open(data.data.download_url, "_blank");
                this.closeDailog();
              } else {
                this.$message({
                  message: data.message,
                  type: "error",
                });
              }
            });
        }
      });
    },
  },
  components: { Pagination },
};
</script>

<style scoped>
.tab {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
</style>